export default __webpack_public_path__ + "static/media/PankajFull.bd8b9b5d.webp";